import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BellIcon, CalendarIcon, ScaleIcon, FolderIcon, SearchIcon, DatabaseIcon } from 'lucide-react';
interface BottomNavProps {
  closeImpressum: () => void;
}
export const BottomNav: React.FC<BottomNavProps> = ({
  closeImpressum
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [weight, setWeight] = useState(450);
  const isWeighingPage = location.pathname === '/weighing';
  const isStatisticsPage = location.pathname === '/statistics';
  const isHorseSelectionPage = location.pathname === '/select-horse';
  // Generate fluctuating weight values when on weighing page
  useEffect(() => {
    if (isWeighingPage) {
      const interval = setInterval(() => {
        // Generate random weight between 420 and 530 kg
        const newWeight = Math.floor(420 + Math.random() * 110);
        setWeight(newWeight);
      }, 800); // Update every 800ms
      return () => clearInterval(interval);
    }
  }, [isWeighingPage]);
  const handleNavigation = (path: string) => {
    closeImpressum(); // Close the impressum when navigating
    navigate(path);
  };
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 rounded-t-xl shadow-lg z-50" data-id="element-20">
      <div className="relative flex justify-around items-center h-20 px-6 bg-[#284755]" data-id="element-21">
        {/* Database (Stammdaten) */}
        <button onClick={() => handleNavigation('/master-data')} className={`flex flex-col items-center justify-center ${location.pathname === '/master-data' ? 'text-[#96c11f]' : 'text-white hover:text-[#96c11f]'}`} data-id="element-22">
          <DatabaseIcon size={20} data-id="element-23" />
        </button>
        {/* Center Weight Display / Weighing Button */}
        <button onClick={() => handleNavigation('/select-horse')} className={`flex flex-col items-center justify-center ${isWeighingPage || isHorseSelectionPage ? 'text-[#96c11f]' : 'text-white hover:text-[#96c11f]'}`} data-id="element-24">
          {isWeighingPage ? <div className="text-4xl font-bold" data-id="element-25">{weight} kg</div> : <ScaleIcon size={24} data-id="element-26" />}
        </button>
        {/* Statistics */}
        <button onClick={() => handleNavigation('/statistics')} className={`flex flex-col items-center justify-center ${isStatisticsPage ? 'text-[#96c11f]' : 'text-white hover:text-[#96c11f]'}`} data-id="element-27">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cX35aqsGXRGgUApqor6qop/chart-no-axes-combined.svg" alt="Statistics" className={`w-5 h-5 ${isStatisticsPage ? 'filter-none' : 'brightness-0 invert'}`} style={isStatisticsPage ? {
          filter: 'brightness(0) saturate(100%) invert(67%) sepia(29%) saturate(1122%) hue-rotate(42deg) brightness(92%) contrast(88%)'
        } : {}} data-id="element-28" />
        </button>
      </div>
    </div>;
};